import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './HighlightsSection.scss';

import CardSliderBlock from "../../Blocks/CardSlider/CardSliderBlock";
import AdvantagesBlock from '../../Blocks/Advantages/AdvantagesBlock';

interface IHighlightsSectionProps {
  context?: IContent;
}

const HighlightsSection = ({ context }: IHighlightsSectionProps) => {
  return (
    <div className="section-highlights">
      <CardSliderBlock />
      <AdvantagesBlock />
    </div>
  );
};

export default withContent(HighlightsSection);
